import { createContext } from 'react'
import type { RefObject } from 'react'

/** The existing evidence region owns the remaining canvas capacity. */
export const EvidenceFlow = createContext<RefObject<HTMLDivElement> | null>(null)
